module.exports = __webpack_public_path__ + "static/media/forgot.7e525e91.png";